//React
import React, { useEffect, useState, useMemo, useRef } from 'react';
import { Form, Card } from 'react-bootstrap';
//API
import { DistributorApi, AccountApi } from '../../apis/index';
//hooks
import useValidation from '../../hooks/useValidation.js';
//Material-UI
import Grid from '@material-ui/core/Grid';
import { styled } from '@mui/material/styles';
import AutoComplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import ReactSecureStorage from 'react-secure-storage';

//Components
import MyLoading from '../../components/Loading.js';
import BasicModal, { ModalComponent } from '../../components/Modal.js';
import countryCodeName from '../../components/countryCode.js';

const CustomFormControl = styled(Form.Control)`
  &:focus {
    outline: none;
    box-shadow: none;
  }
`;

const HospitalRequest = (props) => {
  const [email, setEmail] = useState(''); // input
  const [hospitalName, setHospitalName] = useState(); // input
  const [countryCode, setCountryCode] = useState(); // input
  const [personalInfoAgree, setPersonalInfoAgree] = useState(''); // input
  const [department, setDepartment] = useState(); // input
  const [distributorEmail, setDistributorEmail] = useState(); // input

  const [departmentList, setDepartmentList] = useState([]);

  const [emailCheck, setEmailCheck] = useState(0);
  const [loading, setLoading] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalStatus2, setModalStatus2] = useState(false);
  const [CheckmodalContent, setCheckmodalContent] = useState('');

  const { validateName, validateLocation } = useValidation();

  const [open, setOpen] = useState({
    termsOfUse: false,
    privacyPolicy: false,
    dataCollection: false,
  });

  // 각 섹션의 높이를 관리하기 위한 ref
  const sectionRefs = {
    termsOfUse: useRef(null),
    privacyPolicy: useRef(null),
    dataCollection: useRef(null),
  };

  // 내용 상태
  const [content, setContent] = useState({
    termsOfUse: 'Loading...',
    privacyPolicy: 'Loading...',
    dataCollection: 'Loading...',
  });

    // API에서 불러올 txt 파일 경로 (섹션별)
  const filePathsBySection = {
    termsOfUse: 'terms/TermsOfUse_en.txt',
    privacyPolicy: 'terms/PrivacyPolicy_en.txt',
    dataCollection: 'terms/PersonalDataCollectionAndProcessingAgreement_require_EN.txt',
  };

  // txt 파일 로드 (API로 파일 내용 받아서 content에 텍스트로 설정)
  const loadFileContent = async (section) => {
    const path = filePathsBySection[section];
    if (!path) return;
    try {
      const result = await DistributorApi.getTermsOfUse(path);
      const text = typeof result === 'string' ? result : (result?.data ?? result?.content ?? String(result ?? ''));
      setContent((prevContent) => ({
        ...prevContent,
        [section]: text || 'No content.',
      }));
    } catch (error) {
      console.error(`Failed to load ${section}:`, error);
      setContent((prevContent) => ({
        ...prevContent,
        [section]: 'Failed to load content.',
      }));
    }
  };

  // 처음 로드될 때 txt 파일 가져오기
  useEffect(() => {
    loadFileContent('termsOfUse');
    loadFileContent('privacyPolicy');
    loadFileContent('dataCollection');
  }, []);

  const toggleOpen = (section) => {
    setOpen((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  // 각 섹션의 높이를 계산해서 애니메이션 적용
  const getHeight = (section) => {
    return open[section] ? sectionRefs[section].current.scrollHeight : 0;
  };

  useEffect(() => {
    getCurrentAccount();
    getDepartmentList();
  }, []);

  const getCurrentAccount = async () => {
    try {
      const uid = ReactSecureStorage.getItem('uid');
      const res = await AccountApi.getAccount(uid);
      setDistributorEmail(res.data.email);
      setCountryCode(res.data.countryCode);
    } catch (error) {
      console.error('Failed to fetch getCurrentAccount data:', error);
    }
  };

  const getDepartmentList = async () => {
    try {
      const departmentRes = await DistributorApi.getDepartmentList();
      setDepartmentList(departmentRes.data);
    } catch (error) {
      console.error('Failed to fetch getDepartmentList data:', error);
    }
  };

  const handleChangeCountryCode = (e, value) => {
    if (value) {
      setCountryCode(value.label);
    } else {
      setCountryCode('');
    }
  };

  const handleDepartment = (e, value) => {
    if (value && value.includes("ORP1")) {
      setDepartment("ORP1");
    } else {
      setDepartment(value || '');
    }
  };

  const validateEmail = (email) => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    return regex.test(email);
  };

  const handleChangeEmail = (e) => {
    if (!validateEmail(e.target.value)) {
      setEmailStyle1({ border: '1px solid red' });
      setEmailCheck(1);
    } else {
      setEmailCheck(2);
      setEmailStyle1({ border: '1px solid #3F598C' });
    }
    if (e.target.value.length === 0) {
      setEmailCheck(0);
    }
    setEmail(e.target.value);
  };

  const handleChangeAgree = (event) => {
    setPersonalInfoAgree(event.target.value === 'true');
  };

  const requestDistributor = async (e) => {
    e.preventDefault();

    // FormData 초기화 및 필수 항목 확인
    const formData = new FormData();

    // 이메일 관련 검증 및 모달 처리
    if (!email || !email.trim()) {
      showModalWithContent('Please enter a email.');
      handleModalOpen();
      return;
    } else if (!validateEmail(email)) {
      showModalWithContent('Please enter a valid email address.');
      handleModalOpen();
      return;
    }
    if (email && !validateEmail(email)) {
      showModalWithContent('Please enter a valid email address.');
      handleModalOpen();
      return;
    }

    if (!hospitalName) {
      showModalWithContent('Please set Hospital Name.');
      handleModalOpen();
      return;
    }
    if (validateName(hospitalName) === false) {
      showModalWithContent('Please enter a valid Hospital name.');
      handleModalOpen();
      return;
    }

    if (!countryCode) {
      showModalWithContent('Please select a country code.');
      handleModalOpen();
      return;
    }

    if (!department) {
      showModalWithContent('Please select a department.');
      handleModalOpen();
      return;
    }

    if (!personalInfoAgree) {
      showModalWithContent(
        'Please agree to provide your personal information.',
      );
      handleModalOpen();
      return;
    }

    formData.append('email', email);
    formData.append('hospitalName', hospitalName);
    formData.append('countryCode', countryCode);
    formData.append('department', department);
    formData.append('personalInfoAgree', personalInfoAgree);
    formData.append('distributorEmail', distributorEmail);
    formData.append('distributorName', ReactSecureStorage.getItem('org'));

    try {
      setLoading(true);

      const res = await DistributorApi.hospitalRequest(formData);
      if (res.statusCode === 200) {
        props.history.goBack();
      } else {
        setLoading(false);
        showModalWithContent(res.message);
        handleModalOpen();
        return;
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const handleModalOpen = () => {
    setModalStatus(true);
  };

  const handleModalClose = () => {
    setModalStatus(false);
  };

  const showModalWithContent = (content) => {
    setModalContent(content);
  };

  useEffect(() => {
    if (modalContent) {
      setModalStatus(true);
    }
  }, [modalContent]);

  const [handleClose, setHandleClose] = useState(() => () => { });

  useEffect(() => {
    if (CheckmodalContent) {
      setModalStatus2(true);
    }
  }, [CheckmodalContent]);

  const emailStyle = {
    border: '1px solid #D9D9D9',
  };

  const [emailStyle1, setEmailStyle1] = useState(emailStyle);

  return (
    <div>
      <style>
        {`
          .form-control::placeholder {
            color: #B6BCC5;
          }
          `}
      </style>
      <h1>HOSPITAL ACCOUNT REGISTRATION FORM</h1>
      <div>
        Please enter the following details to request a Hospital Administrator account registration. <br />
        <br />
      </div>
      <Form onSubmit={requestDistributor} onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}>
        <Form.Group>
          <div>Email for Hospital Administrator Account
            <span style={{ color: 'red' }}> *</span>
          </div>
          <div>Please provide an email address that is not expected to change for the Administrator account.</div>
          <div style={{ color: 'red' }}>
            An invitation email will be sent to this address.
          </div>
          <div style={{ display: 'flex', position: 'relative' }}>
            <CustomFormControl
              style={{
                ...(email ? emailStyle1 : emailStyle),
                margin: '0px',
              }}
              type="text"
              placeholder="Enter email address..."
              name="email"
              autoComplete="off"
              onChange={handleChangeEmail}
              maxLength={30}
            />
            <div
              style={{
                display: emailCheck === 1 ? 'block' : 'none',
                position: 'absolute',
                right: '10px',
                top: '50%',
                color: 'red',
                transform: 'translateY(-50%) rotate(180deg)',
              }}
            >
              <InfoOutlinedIcon color="red" />
            </div>
            <div
              style={{
                display: emailCheck === 2 ? 'block' : 'none',
                position: 'absolute',
                right: '10px',
                top: '7px',
                color: '#3F598C',
              }}
            >
              <CheckCircleOutlinedIcon />
            </div>
          </div>
          {emailCheck === 1 ? (
            <div style={{ color: 'red', fontSize: '12px' }}>Invalid email
            </div>
          ) : (
            <div style={{ paddingBottom: '17px' }}>
            </div>
          )}
        </Form.Group>
        <Form.Group>
          <span>Hospital Name</span>
          <span style={{ color: 'red' }}> *</span>
          <Form.Control
            style={{ margin: '0px' }}
            type="text"
            placeholder="Enter name..."
            name="hospitalName"
            autoComplete="off"
            onChange={(e) => setHospitalName(e.target.value)}
            maxLength={30}
          />
        </Form.Group>
        <Form.Group>
          <div style={{ width: '300px', marginRight: '15px' }}>
            <span>Country Code</span>
            <span style={{ color: 'red' }}> *</span>
            <AutoComplete
              disabled={true}
              size="small"
              disablePortal
              options={countryCodeName}
              name="countryCode"
              onChange={handleChangeCountryCode}
              value={countryCode || ''}
              sx={{ width: '100%' }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Enter country code..."
                  sx={{
                    '& legend': { display: 'none' },
                    '& fieldset': { top: 0 },
                  }}
                />
              )}
            />
          </div>
          <div style={{ marginTop: '5px' }}>
            <a
              href="https://www.countrycode.org/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ fontSize: '15px', color: '#007bff', textDecoration: 'none' }}
            >
              Click here if you don't know your country code.
            </a>
          </div>
        </Form.Group>
        <Form.Group>
          <div style={{ width: '300px', marginRight: '15px' }}>
            <span>ROKIT HEALTHCARE Department</span>
            <span style={{ color: 'red' }}> *</span>
            <AutoComplete
              style={{ backgroundColor: 'white' }}
              size="small"
              disablePortal
              options={departmentList.map((dept) =>
                dept === 'ORP1' ? 'ORP1 (SKIN)' : dept
              )}
              name="department"
              value={department === 'ORP1' ? 'ORP1 (SKIN)' : department || ''}
              onChange={handleDepartment}
              sx={{ width: '100%' }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select Department"
                  sx={{
                    '& legend': { display: 'none' },
                    '& fieldset': { top: 0 },
                  }}
                />
              )}
            />
          </div>
        </Form.Group>
        <Form.Group>
          <span>Privacy And Terms</span>
          <span style={{ color: 'red' }}> *</span>

          <div
            style={{
              border: '2px solid #ccc', // 테두리 스타일
              borderRadius: '8px', // 모서리 둥글게
              padding: '16px', // 안쪽 여백
              width: '100%', // 내용 크기에 맞게 조절
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
            }}
          >
            {/* Terms of Use */}
            <Card style={{ marginBottom: '10px', borderRadius: '8px', overflow: 'hidden' }}>
              <Card.Header
                style={{
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
                onClick={() => toggleOpen('termsOfUse')}
              >
                <span>Terms of Use</span>
                <span>{open.termsOfUse ? '▲' : '▼'}</span>
              </Card.Header>
              <div
                ref={sectionRefs.termsOfUse}
                style={{
                  height: getHeight('termsOfUse'),
                  overflow: 'hidden',
                  transition: 'height 0.3s ease',
                }}
              >
                <Card.Body>
                  <Form.Control
                    as="textarea"
                    disabled
                    rows={10}
                    value={content.termsOfUse}
                    style={{
                      width: '100%',
                      resize: 'none',
                      fontFamily: 'Roboto, sans-serif',
                      fontSize: '14px', // 글자 크기
                      lineHeight: '1.6', // 가독성 향상
                      color: '#333', // 글자 색상
                    }}
                  />
                </Card.Body>
              </div>
            </Card>

            {/* Data Collection */}
            <Card style={{ marginBottom: '10px', borderRadius: '8px', overflow: 'hidden' }}>
              <Card.Header
                style={{
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
                onClick={() => toggleOpen('dataCollection')}
              >
                <span>Personal Data Collection and Processing Agreement</span>
                <span>{open.dataCollection ? '▲' : '▼'}</span>
              </Card.Header>
              <div
                ref={sectionRefs.dataCollection}
                style={{
                  height: getHeight('dataCollection'),
                  overflow: 'hidden',
                  transition: 'height 0.3s ease',
                }}
              >
                <Card.Body>
                  <Form.Control
                    as="textarea"
                    disabled
                    rows={10}
                    value={content.dataCollection}
                    style={{
                      width: '100%',
                      resize: 'none',
                      fontFamily: 'Roboto, sans-serif',
                      fontSize: '14px', // 글자 크기
                      lineHeight: '1.6', // 가독성 향상
                      color: '#333', // 글자 색상
                    }}
                  />
                </Card.Body>
              </div>
            </Card>

            {/* Privacy Policy */}
            <Card style={{ marginBottom: '10px', borderRadius: '8px', overflow: 'hidden' }}>
              <Card.Header
                style={{
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
                onClick={() => toggleOpen('privacyPolicy')}
              >
                <span>Privacy Policy</span>
                <span>{open.privacyPolicy ? '▲' : '▼'}</span>
              </Card.Header>
              <div
                ref={sectionRefs.privacyPolicy}
                style={{
                  height: getHeight('privacyPolicy'),
                  overflow: 'hidden',
                  transition: 'height 0.3s ease',
                }}
              >
                <Card.Body>
                  <Form.Control
                    as="textarea"
                    disabled
                    rows={10}
                    value={content.privacyPolicy}
                    style={{
                      width: '100%',
                      resize: 'none',
                      fontFamily: 'Roboto, sans-serif',
                      fontSize: '14px', // 글자 크기
                      lineHeight: '1.6', // 가독성 향상
                      color: '#333', // 글자 색상
                    }}
                  />
                </Card.Body>
              </div>
            </Card>

            {/* 동의 여부 */}
            <div style={{ marginTop: '20px', display: 'flex', alignItems: 'center', gap: '12px' }}>
              <label style={{ fontSize: '14px', fontWeight: 'bold' }}>
                Do you agree to the collection and use of personal information?
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '14px' }}>
                <input
                  type="radio"
                  name="personalInfoAgree"
                  value="true"
                  checked={personalInfoAgree === true}
                  onChange={handleChangeAgree}
                  style={{ width: '16px', height: '16px', cursor: 'pointer' }}
                />
                Yes
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '14px' }}>
                <input
                  type="radio"
                  name="personalInfoAgree"
                  value="false"
                  checked={personalInfoAgree === false}
                  onChange={handleChangeAgree}
                  style={{ width: '16px', height: '16px', cursor: 'pointer' }}
                />
                No
              </label>
            </div>
          </div>
        </Form.Group>

        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <button
            type="button"
            onClick={() => props.history.goBack()}
            style={{ marginRight: '25px', fontSize: '18px', fontWeight: '500' }}
          >
            BACK
          </button>
          <button
            className="blue"
            type="submit"
            style={{ maringLeft: '25px', fontSize: '18px', fontWeight: '500' }}
          >
            REQUEST
          </button>
        </Grid>
      </Form>
      <div style={{ display: 'none' }}>
        <BasicModal
          open={modalStatus}
          handleModalClose={handleModalClose}
          content={modalContent}
        />
        <ModalComponent
          open={modalStatus2}
          handleModalClose={(userChoice) => handleClose(userChoice)}
          content={CheckmodalContent}
        />
      </div>
      {loading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <MyLoading />
        </div>
      )}
    </div>
  );
};

export default HospitalRequest;
